export const DEFAULT_WENT_WRONG_HEADING = "Something Went Wrong!"
export const DEFAULT_NO_DATA_HEADING = "No Data To Display!"
export const CLOUD_ALERTS_NO_DATA_HEADING = "No Alerts To Display!"
export const NOT_ACCESSIBLE_TO_CLIENT = "Not accessible to the client"
